var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 426,
    height: 124,
    viewBox: "0 0 426 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.0195 4.72196e-07H413.315C415.415 -0.000590487 417.479 0.553524 419.297 1.60658C421.116 2.65964 422.626 4.1745 423.676 5.99871C424.725 7.82292 425.277 9.89213 425.276 11.9981C425.274 14.1041 424.72 16.1726 423.668 17.9954L365.965 118.015C364.917 119.83 363.412 121.338 361.6 122.388C359.789 123.439 357.735 123.994 355.643 124H11.9624C9.87396 124.001 7.82173 123.453 6.00997 122.412C4.1982 121.37 2.69009 119.871 1.63574 118.063C0.581387 116.256 0.0175688 114.203 0.000403989 112.108C-0.0167608 110.014 0.513326 107.952 1.5379 106.128L57.5848 6.14876C58.6229 4.28712 60.1368 2.73627 61.9707 1.65563C63.8046 0.574983 65.8924 0.00352715 68.0195 4.72196e-07Z",
    fill: "#004386"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M278.167 30.0608L273.057 40.3087H107.492C107.492 40.3087 80.9197 39.2839 69.6776 60.8046C63.5455 83.3501 93.1838 78.2261 93.1838 78.2261L103.404 60.8046H94.2058L100.338 50.5567H132.02L109.536 89.4988H66.6116C66.6116 89.4988 45.1494 84.3748 45.1494 63.879C45.1494 43.3831 77.8537 30.0608 108.514 30.0608H278.167Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M206.627 44.4076C206.627 44.4076 158.592 38.2588 133.042 63.8786C110.558 87.4489 139.174 104.87 139.174 104.87L149.394 94.6224C149.394 94.6224 140.196 89.4985 145.306 78.2257H164.724L159.614 89.4985H180.054L197.428 59.7795H175.966L171.878 66.953H153.482C153.482 66.953 157.57 52.6059 199.472 55.6803C203.561 49.5315 206.627 44.4076 206.627 44.4076Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M212.759 43.3828H271.013L226.045 78.2258H251.595L244.441 89.4985H187.208L232.177 55.6803H205.605L212.759 43.3828Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M288.387 30.0608H314.959L308.827 40.3087H283.277L288.387 30.0608Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M324.158 30.0608H388.544L382.412 40.3087H319.047L324.158 30.0608Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M282.255 43.3828H307.805L280.211 89.4985H254.661L282.255 43.3828Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M317.003 43.3828H342.554L347.664 58.7547L356.862 43.3828H381.39L353.796 90.5233H329.268L336.422 77.201L330.29 59.7795L312.915 90.5233H290.431L317.003 43.3828Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d5c4faf807e97ad4dc68f11147bc2d1b.svg";
export { ForwardRef as ReactComponent };